import useAPI, { RequestConfig } from './useApi';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import { notificationsActions } from '@lifeomic/phc-web-toolkit/dist/redux/modules/notifications';
import urls from '../../util/urls';
import { useIntl } from 'react-intl';
import { AxiosError, AxiosResponse } from 'axios';
import config from '../../util/config';
import { loginSelectors } from '../../redux/modules/Login';

const messages = {
  apiErrorMessage: {
    id: 'passwordlessEndpoint.apiErrorMessage',
    defaultMessage:
      'An error occurred when sending an email to login via a link.  Error: "{error}"',
  },
  genericError: {
    id: 'passwordlessEndpoint.genericError',
    defaultMessage: 'An error occurred when sending an email for logging in.',
  },
};

export type PasswordlessResponse = { session: string };

function usePasswordlessEndpoint() {
  const dispatch = useDispatch();
  const formatMessage = useIntl().formatMessage;
  const customClientId = useSelector(loginSelectors.selectCustomClientId);

  const clientId = customClientId || config.oauthClientId;

  const onFailure = (error: AxiosError) => {
    const errorMessage = get(error, 'response.data.error', null) as string;

    const notificationMessage = errorMessage
      ? formatMessage(messages.apiErrorMessage, { error: errorMessage })
      : formatMessage(messages.genericError);

    dispatch(
      notificationsActions.addNotification(notificationMessage, {
        statusType: 'error',
      })
    );
  };

  const makeAPIRequest = (
    username: string,
    onSuccess: (axiosResponse: AxiosResponse<PasswordlessResponse>) => void
  ): RequestConfig => ({
    url: urls.api.auth.passwordlessAuth,
    method: 'POST',
    headers: {
      'content-type': 'application/json',
    },
    data: {
      username,
      clientId,
      loginAppBasePath: config.loginAppBasePath,
      appsBaseUri: `${window.location.protocol}//${window.location.host}`,
    },
    onSuccess,
    onFailure,
  });

  return useAPI(makeAPIRequest);
}

export default usePasswordlessEndpoint;
